import { render, staticRenderFns } from "./ExtraData.vue?vue&type=template&id=9ea9523a&"
import script from "./ExtraData.vue?vue&type=script&lang=js&"
export * from "./ExtraData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports